export default {
    "slug": "war",
    "title": "war",
    "firstChapterKey": "y1",
    "player": require("./player.js").default,
    "chapters": {
        "y1": require("./y1").default,
        "y2": require("./y2").default,
        "y3": require("./y3").default,
        "y4": require("./y4").default,
        "y5": require("./y5").default,
        "g1": require("./g1").default,
        "g3": require("./g3").default,
        "g4": require("./g4").default,
        "r4": require("./r4").default,
        "demo": require("./demo").default,
    },
    "configuration": {
        "darkness": false,
        "squigglevision": false,
    },
    "tests": {
        "win": require("./tests/y4_winChapter.json"),
        "pullback": require("./tests/pullback.json"),
        "rally": require("./tests/rally.json"),
    },
    "demoes": {
        "inflict-damage": require("./demo/attack_demo.json"),
        "rally": require("./demo/rally_demo.json"),
        "smite": require("./demo/push_demo.json"),
    }
}
